<template>
  <div class="header" :class="{selectbj: showHeadColor}">
    <div class="header-pc">
      <img src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/logo.png" alt="" class="logo"/>
      <div class="nav" @mouseover="showHeadBj" @mouseout="hideHeadBj">
        <div class="menu"  @click="toIndex">首页</div>
        <div class="menu" @click="toInformationCenter">
          资讯中心
          
        </div>
        <div class="menu" @click="toProductCenter" >产品中心</div>
        <div class="menu" @click="toProjectCenter" >
          项目中心
          
        </div>
        <div @click="toAboutWe" class="menu" >关于我们
          <div class="menu-more">
          <div class="menu-C" @click="togsjj">公司简介</div>
          <div class="menu-C" @click="toqywh">企业文化</div>
          <div class="menu-C" @click="toryzz">荣誉资质</div>
          <div class="menu-C" @click="tofzlc">发展历程</div>
          <div class="menu-C" @click="tolxwm">联系我们</div>
        </div>
        </div>
        
      </div>
    </div>
    <div class="header-mb">
      <img src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/logo.png" alt="" class="logo-mb"/>
      <div class="nav-mb">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <img src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/mb-menu.png" alt="" class="mb-menu">
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>首页</el-dropdown-item>
            <el-dropdown-item>资讯中心</el-dropdown-item>
            <el-dropdown-item>产品中心</el-dropdown-item>
            <el-dropdown-item>项目中心</el-dropdown-item>
            <el-dropdown-item>关于我们</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "home-header",
  props: {
    isActive: String
  },
  data() {
    return {
      showHeadColor: false
    };
  },
  methods: {
    togsjj() {
      this.$parent.togsjj()
    },
    toqywh(){
this.$parent.toqywh()
    },
    toryzz() {
this.$parent.toryzz()
    },
    tofzlc() {
this.$parent.tofzlc()
    },
    tolxwm() {
this.$parent.tolxwm()
    },
    showHeadBj() {
      this.showHeadColor = true
    },
    hideHeadBj() {
      this.showHeadColor = false
    },
    toAboutWe() {
      this.$router.push('/AboutWe')
    },
    toIndex() {
      this.$router.push('/')
    },
    toProductCenter() {
      this.$router.push('/ProductCenter')
    },
    // 产品中心
    toProjectCenter() {
      this.$router.push('/ProjectCenter')
    },
    toInformationCenter() {
      this.$router.push('/InformationCenter')
    }
  }
};
</script>
<style scoped>
.header-pc {
  width: 1200px;
  height: 72px;
  margin: 0 auto;
  display: flex;
  position: relative;
}


.active {
  color: #006CDA !important;
  border-bottom: 2px solid #006CDA;
  position: relative;
}
.menu {
  position: relative;
}
.menu:hover {
  color: #006CDA !important;
  border-bottom: 2px solid #006CDA;
}
.menu-C:hover {
  color: #006CDA !important;
}
.menu-more {
  position: absolute;
  background-color: rgba(8, 6, 27, 0.5) !important;
  list-style: none;
  line-height: 40px;
  display: none;
  left: -50px;
  width: 160px;
  color: #fff;
  opacity: 0;
  overflow: hidden;
}
.mb-menu {
  width: 30px;
}
.menu:hover .menu-more {
  display: block;
  opacity: 1;
  transition: 0.5s;
}
.header-mb{
  display: none;
  padding: 20px;
}
.header {
  z-index: 9999;
  position: absolute;
  /* top: 70px; */
  width: 100%;
  text-align: center;
  
}

.selectbj {
  transition: 0.5s;
  background-color: rgba(8, 6, 27, 0.7) !important;
}
.nav {
  height: 72px;
  line-height: 72px;
  display: flex;
}
.nav > div {
  margin: 0 35px;
  color: #fff;
  font-size: 16px;
  font-family: Microsoft Yahei;
  font-weight: 600;
  color: #FFFFFF;
  cursor: pointer;
}
.logo {
  width: 140px;
  height: 36px;
  margin-top: 18px;
  margin-right:200px ;
}
.logo-mb {
  width: 140px;
  height: 36px;
}
.nav-mb {
  flex-shrink: 0;
  margin-right: 30px;
}
@media only screen and (max-width:1024px ) {
  .header-pc {
    display: none;
  }
  .header-mb {
    display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue